/* eslint-disable max-len */
import { template_translation } from '../lang/TemplateTranslation';
const t = template_translation;

/** 8.ARで複数のマーカーに反応させる */
export const template8 = {
  title: t.to('ARで複数のマーカーに反応する', 'title8'),
  desc: t.to('ARモードで複数のマーカーに反応するようにします', 'desc8'),
  img: '../public/template/8.png',
  xml: `
  <xml xmlns="http://www.w3.org/1999/xhtml">
    <variables>
    </variables>
    <block type="a-scene-start" x="210" y="190">
      <value name="ATTR">
        <block type="ar_scene_setting_attribute_v2">
          <field name="debugUIEnabled">false</field>
        </block>
      </value>
      <statement name="IN">
        <block type="a-camera_v2.1">
          <field name="position-x">0</field>
          <field name="position-y">0</field>
          <field name="position-z">0</field>
          <next>
            <block type="ar_marker_v2">
              <value name="ATTR">
                <block type="ar_hiro_attribute_v2">
                </block>
              </value>
              <statement name="IN">
                <block type="sphere_v2">
                  <field name="id">block1</field>
                  <field name="position-x">0</field>
                  <field name="position-y">0</field>
                  <field name="position-z">0</field>
                  <value name="COLOUR">
                    <shadow type="color_value_v2">
                      <field name="COLOUR">#ff0000</field>
                    </shadow>
                  </value>
                </block>
              </statement>
              <next>
                <block type="ar_marker_v2">
                  <value name="ATTR">
                    <block type="ar_barcode_attribute_v2">
                      <field name="value">1</field>
                    </block>
                  </value>
                  <statement name="IN">
                    <block type="cube_v2">
                      <field name="id">block1</field>
                      <field name="position-x">0</field>
                      <field name="position-y">0</field>
                      <field name="position-z">0</field>
                      <value name="COLOUR">
                        <shadow type="color_value_v2">
                          <field name="COLOUR">#0027c4</field>
                        </shadow>
                      </value>
                    </block>
                  </statement>
                  <next>
                    <block type="ar_marker_v2">
                      <value name="ATTR">
                        <block type="ar_barcode_attribute_v2">
                          <field name="value">0</field>
                        </block>
                      </value>
                      <statement name="IN">
                        <block type="cube_v2">
                          <field name="id">block1</field>
                          <field name="position-x">0</field>
                          <field name="position-y">0</field>
                          <field name="position-z">0</field>
                          <value name="COLOUR">
                            <shadow type="color_value_v2">
                              <field name="COLOUR">#00ff00</field>
                            </shadow>
                          </value>
                        </block>
                      </statement>
                    </block>
                  </next>
                </block>
              </next>
            </block>
          </next>
        </block>
      </statement>
    </block>
  </xml>
  `,
};
